import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const DriverBookingPerformanceChart = ({ data }) => {
  const drivers = Array.isArray(data?.drivers) ? data.drivers : [];

  const categories = useMemo(
    () => drivers.map((driver) => driver?.name || "Unknown Driver"),
    [drivers]
  );

  const series = useMemo(
    () => [
      {
        name: "Assigned Bookings",
        data: drivers.map((driver) => Number(driver?.assignedBookings) || 0),
      },
      {
        name: "Completed Bookings",
        data: drivers.map((driver) => Number(driver?.completedBookings) || 0),
      },
    ],
    [drivers]
  );

  const options = useMemo(
    () => ({
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "45%",
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      colors: ["#2D9CDB", "#27AE60"],
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      xaxis: {
        categories,
        title: {
          text: "Driver",
        },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        title: {
          text: "No. of Bookings",
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      noData: {
        text: "No driver performance data available",
      },
    }),
    [categories]
  );

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title mb-0">Driver Booking Performance</h4>
      </div>
      <div className="card-body">
        <div className="line-chart-style bar-chart">
          <ReactApexChart options={options} series={series} type="bar" height={360} />
        </div>
      </div>
    </div>
  );
};

export default DriverBookingPerformanceChart;
